import { TenantModel } from '@/models/roster/tenant';
import {
    TENANT_SETTINS_TOGGLE_ELEMENT, TENANT_SETTINS_PARAMETER_TYPE,
    TENANT_SETTINS_CUSTOM_UI_COMPONENT,
    UPLOAD_TYPE_LIST,
    TENANT_SETTINS_DISABLED_SETTING_KEY,
} from '@/utils/constants';
import { TENANT_SETTINGS_LABEL_KEYS } from '@/utils/tenant-setting';
import { checkCDNUrl } from '@/utils/utils';
import { Vue } from 'vue-property-decorator';

export class TenantSettingsSerializer extends Vue {

    public static INSTANCE = new TenantSettingsSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    /**
     * serializeTenantSettings
     */
    public serializeActiveTenantSettings(payload: any) {
        return payload ? payload.tenant_settings : {};
    }

    public serializeTenantSettingById(payload: any) {
        const payloadData = payload ? payload.tenant_settings : {};
        return Object.fromEntries(payloadData.map(({ key, value }: any) => [key, value]));
    }

    public serializeTenantSettings(payload: any) {
        const results: any = [];
        if (payload && payload.tenant_settings) {
            payload.tenant_settings.forEach((settings: any) => {
                results.push(settings);
            });
        }
        return results;
    }

    public serializeClassification(payload: any) {
        return payload ? payload.classifications : [];
    }

    public serializeTaxonomyClassifications(taxonomyClassifications: any) {
        return taxonomyClassifications ? taxonomyClassifications.subject_classifications : [];
    }

    public serializeTenantSetting(payload: any) {
        const tenantPayload = payload ? payload : {};
        const tenantDetail: TenantModel = {
            grantTypes: tenantPayload.grantTypes || null,
            id: tenantPayload.id || null,
            loginUrl: tenantPayload.loginUrl || null,
            name: tenantPayload.name || null,
            parentTenant: tenantPayload.parenTenant || null,
            shortName: tenantPayload.shortName || null,
            status: tenantPayload.status || null,
            tenantType: tenantPayload.tenantType || null,
        };
        return tenantDetail;
    }

    public serializeTenantSettingByGroup(payload: any) {
        const that = this;
        const tenantPayload = payload ? payload.tenant_config : [];
        let tenantObj: any;
        tenantObj = tenantPayload.reduce((r: any, a: any) => {
            a.groupName = a.groupName ? TENANT_SETTINGS_LABEL_KEYS[a.groupName] : 'general';
            a.isExpand = false;
            a.parentKey = a.settingKey.indexOf('~') !== -1 ? that.getParentKey(a.settingKey, 0) : null;
            a.keyName = a.settingKey.indexOf('~') !== -1 ? that.getParentKey(a.settingKey, 1) : a.settingKey;
            that.getFieldType(a);
            a.isDisable = a.accessMode === 'view' ? true : false;
            r[a.groupName] = r[a.groupName] || [];
            r[a.groupName].push(a);
            return r;
        }, Object.create(null));

        return tenantObj;
    }

    public serializeTenantSettingByGroupRaw(payload: any) {
        const tenantPayload = payload ? payload.tenant_config : [];
        return tenantPayload;
    }

    public serializeTenantSettingRawList(payload: any) {
        const tenantPayload = payload ? payload.tenant_config : [];
        return tenantPayload;
    }

    public serializeTenantDetailsSetting(payload: any) {
        const tenantPayload = payload ? payload : {};
        return tenantPayload;
    }

    private getParentKey(settingKey: any, childParent: any) {
        const splitItem = settingKey.split('~');
        return splitItem[childParent];
    }

    private getFieldType(settingObject: any) {
        if (settingObject.selectOption && settingObject.selectOption.options) {
            settingObject.options = settingObject.selectOption;
            settingObject.fieldType = 'b-form-select';
        } else if (TENANT_SETTINS_CUSTOM_UI_COMPONENT.hasOwnProperty(settingObject.keyName)) {
            settingObject.fieldType = TENANT_SETTINS_CUSTOM_UI_COMPONENT[settingObject.keyName];
        } else if (TENANT_SETTINS_TOGGLE_ELEMENT.includes(settingObject.uiElementType)) {
            settingObject.fieldType = TENANT_SETTINS_PARAMETER_TYPE[settingObject.uiElementType];
            settingObject.options = {
                switch: true,
                disabled: TENANT_SETTINS_DISABLED_SETTING_KEY.includes(settingObject.settingKey) ? true : false,
            };
        } else if (UPLOAD_TYPE_LIST.includes(settingObject.keyName)) {
            settingObject.fieldType = 'b-form-file';
        } else {
            settingObject.fieldType = TENANT_SETTINS_PARAMETER_TYPE[settingObject.uiElementType];
        }
    }
}

export const tenantSettingsSerializer = TenantSettingsSerializer.instance;
